module.exports = __webpack_public_path__ + "img/youhui.deb3937f.png";